<finance-pwa-top-bar></finance-pwa-top-bar>

<section class="page-shell" *ngIf="data$ | async as vm">
  <header class="space-y-2">
    <p class="eyebrow">Group equity</p>
    <h1 class="display-value">{{ formatMoney(vm.summary.totalEquity) }}</h1>
    <div class="inline-stats">
      <span class="chip chip-success">{{ vm.summary.healthPercent }}% healthy</span>
      <span class="chip">Paid {{ formatMoney(vm.summary.paid) }}</span>
      <span class="chip">Remaining {{ formatMoney(vm.summary.remaining) }}</span>
    </div>
  </header>

  <article class="surface-low rounded-2xl p-5">
    <h2 class="card-title">Contributed vs Target By Asset</h2>
    <finance-pwa-repayment-chart
      [projected]="vm.charts.target"
      [actual]="vm.charts.contributed"
      [categories]="vm.charts.categories"
    ></finance-pwa-repayment-chart>
  </article>

  <article class="surface-low rounded-2xl p-5">
    <h2 class="card-title">Overall Payment Progress vs 2-Year Target</h2>
    <p class="card-subtitle">Target trajectory assumes full payoff for all assets within 24 months.</p>
    <finance-pwa-overall-progress-chart
      [actual]="vm.charts.timelineActual"
      [target]="vm.charts.timelineTarget"
      [categories]="vm.charts.timelineCategories"
    ></finance-pwa-overall-progress-chart>
  </article>

  <article class="surface-low rounded-2xl p-5">
    <div class="flex items-center justify-between gap-3 mb-4">
      <h2 class="card-title">Group partners</h2>
      <span class="text-xs uppercase tracking-[0.14em] text-on-surface-variant">Live snapshot</span>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div *ngFor="let partner of vm.partners" class="surface-lowest rounded-xl p-4 flex items-center justify-between gap-3">
        <div>
          <p class="font-semibold text-primary">{{ partner.name }}</p>
          <p class="text-sm text-on-surface-variant">{{ formatMoney(partner.contribution) }}</p>
        </div>
        <span class="status-pill" [class.status-pill-pending]="!partner.verified">
          {{ partner.verified ? 'Verified' : 'Pending' }}
        </span>
      </div>
    </div>
  </article>
</section>
